import React, { Component } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { incidentsOperations } from '../../redux/incidentList';
import { userOperations } from '../../redux/user';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

class ShareFilterDialog extends Component {

  constructor (props)
  {
    super(props);
 
    this.state =
    {   
        userNifcSearchString: '',
        statusMessage:'',
        foundUser: null
    };
  }

  componentWillReceiveProps(nextProps)
  {
    
  }

  updateSearchString = (value) => {
    this.setState({
        userNifcSearchString: value
      });
  }

  shareFilter = () => {
    window.api.shareUserFilter(this.state.foundUser, this.props.filterForShare).then(response => {

        const displayString = this.state.foundUser.FirstName + " " + this.state.foundUser.LastName;
        this.setState({
            statusMessage: (!response.Success) ? 'Filter sent to ' + displayString : '',
            foundUser: null,
            userNifcSearchString: ''
        });
    });
  }

  handleSuccessSnackRequestClose = () => {
    this.setState({
        statusMessage: "",
    });
  };

  searchUser = () => {
    window.api.searchForUser(this.state.userNifcSearchString).then(response => {

        this.setState({
            foundUser: response.FoundUser
          });

        this.setState({
            statusMessage: (!response.Success) ? 'User not found' : ''
        });
    });
  }

  render() {

    const foundUserName = (this.state.foundUser !== null) ? this.state.foundUser.FirstName + " " + this.state.foundUser.LastName : ""; 
    const filterName = (this.props.filterForShare) ? this.props.filterForShare.Title : '';
    const actions = [
        <Button
        className="reporting-print-btn"
        variant="contained" color="primary"
        disabled={!this.state.foundUser}
        onClick={this.shareFilter}>Share Filter</Button>,
      <Button
        className="reporting-print-btn"
        onClick={this.props.onClose}>Close</Button>
    ];
    
    return (
      <Dialog
        open={this.props.open}
        actions={actions}
        modal={true}
        autoScrollBodyContent={true}
        contentStyle={{ width: '50%', minHeight:"400px", height: '50%', overflowy: 'auto' }}
        className="dialog-modal">
         <Paper>
          <AppBar position="relative">
            <Toolbar variant="dense">
              <Typography variant="h6" color="inherit">
                Share Filter
              </Typography>
              <IconButton color="inherit" onClick={this.props.onClose} style={{ position: "relative", float: "right", marginLeft: "auto" }} aria-label="close">
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
        &nbsp;<br/>
       <div> NIFC Username:&nbsp;
       <TextField value={this.state.userNifcSearchString} style={{ width: "240px" }} onChange={(e) => this.updateSearchString(e.target.value)}/>&nbsp;&nbsp;
       <Button
        variant="contained"
        onClick={this.searchUser}
        disabled={this.state.userNifcSearchString === ''}>Search</Button>
        &nbsp;<br/>
        &nbsp;<br/>
      </div>
      <div hidden={this.state.foundUser === null}>
        Send {filterName} to {foundUserName}? 
      </div>
      <div hidden={this.state.statusMessage === ''}>
        {this.state.statusMessage}
      </div>
      <Snackbar
          open={Boolean(this.state.statusMessage !== '')}
          message={this.state.statusMessage}
          autoHideDuration={5000}
          onClose={this.handleSuccessSnackRequestClose}
        />
      </Paper>
      
      </Dialog>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
  incidentList: state.incidentList
})


const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({
      ...userOperations,
      ...incidentsOperations
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareFilterDialog)
